export default __webpack_public_path__ + "static/media/icon-coin-uma.85c56d57.svg";